import keys from './fr.json';

export default {
  locale: 'fr',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
      true {
        { preposition, select,
          at { le { end } }
          until { jusqu’au { end } }
        }
      }
      other { { duration, plural,
          one { # jour }
          other { # jours }
        }
      }
    }`,
    statusvalue: `{ roundNumber, select,
      0 {
        { content, select,
          Preview { En préparation }
          Resolved { Conclu }
          other { {content} }
        }
      }
      other {
        { roundType, select,
          sealed_bidding { Processus fermé }
          open_bidding { Processus ouvert }
          counteroffer_bidding { Contre-offre }
          incremental_auction { Processus flexible }
          registration { Inscription }
          simple_offer { Offre digitale }
        }
        { roundStatus, select,
          opened { en cours }
          started { commencée }
          closed { terminé }
          other { {roundStatus} }
        }
      }
    }`,
    'Mls::statusvalue': `{ roundType, select,
        sealed_bidding { Processus fermé }
        open_bidding { Processus ouvert }
        counteroffer_bidding { Contre-offre }
        incremental_auction { Processus flexible }
        registration { Inscription }
        simple_offer { Offre digitale }
      }
      { roundStatus, select,
        opened { encore {endAt} }
        started { pas encore ouvert }
        closed { terminé }
        other { {roundStatus} }
      }
    `,
    'RoundInfo::label': `{ type, select,
              sealed_bidding { Processus fermé }
              open_bidding { Processus ouvert }
              counteroffer_bidding { Contre-offre }
              incremental_auction { Processus flexible }
              registration { Inscription }
              simple_offer { Offre digitale }
            }
            { status, select,
              started { pas encore ouvert }
              opened
              {
                { hasEnd, select,
                  true {
                    { durationType, select,
                        fixed {
                          { isPreview, select,
                            true { commence {startDuration} }
                            false {
                              { isPast, select,
                                false { encore {endDuration} }
                                other { terminé }
                              }
                            }
                          }
                        }
                        flexible { encore {durationInDays} jours }
                      }
                    }
                    other {  }
                  }
                }
              closed { terminé { endText } }
              other { {status} }
            }`,
  },

  moment: {
    months:
      'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
        '_'
      ),
    monthsShort:
      'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
        '_'
      ),
    monthsParseExact: true,
    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd D MMMM YYYY HH:mm',
    },
    calendar: {
      sameDay: '[Aujourd’hui à] LT',
      nextDay: '[Demain à] LT',
      nextWeek: 'dddd [à] LT',
      lastDay: '[Hier à] LT',
      lastWeek: 'dddd [dernier à] LT',
      sameElse: 'L',
    },
    relativeTime: {
      future: 'dans %s',
      past: 'il y a %s',
      s: 'quelques secondes',
      ss: '%d secondes',
      m: 'une minute',
      mm: '%d minutes',
      h: 'une heure',
      hh: '%d heures',
      d: 'un jour',
      dd: '%d jours',
      M: 'un mois',
      MM: '%d mois',
      y: 'un an',
      yy: '%d ans',
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal: function (number, period) {
      switch (period) {
        case 'D':
          return number + (number === 1 ? 'er' : '');

        default:
        case 'M':
        case 'Q':
        case 'DDD':
        case 'd':
          return number + (number === 1 ? 'er' : 'e');

        case 'w':
        case 'W':
          return number + (number === 1 ? 're' : 'e');
      }
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/fr.js